import React from 'react';
import { FormElementsButton } from '../../FormElements';

const ChatWithSalesButton = ({
  canChoosePlan,
  currentBundle,
  handleOnClick,
  size = 'md',
  ...props
}) => {
  const commonButtonStyles = {
    size,
    sx: hoverStyles,
    variant: 'primary',
    ...props,
  };

  return currentBundle ? (
    <FormElementsButton size={size} disabled {...commonButtonStyles}>
      Current plan
    </FormElementsButton>
  ) : (
    <FormElementsButton onClick={handleOnClick} {...commonButtonStyles}>
      {canChoosePlan ? 'Choose plan' : 'Chat with a Podium expert'}
    </FormElementsButton>
  );
};

const hoverStyles = { _hover: { backgroundColor: 'blue.dark' } };

export default ChatWithSalesButton;
